import React from "react";
import Headers from "../../../components/Headers";
import {
  Input,
  Form,
  Row,
  Col,
  Button,
  Table,
  Divider,
  message,
  DatePicker,
} from "antd";
import { fetchRefundRecord } from "../../../api/dataAnalysis";
import NProgress from "nprogress";

const BreadCrumbData = [
  { path: "/page/dataanalysis/dataanalysis", name: "数据统计" },
  { path: "/page/capital/earnings", name: "退款记录" },
];
const { RangePicker } = DatePicker;
const { Column } = Table;
class RefundRecord extends React.Component {
  state = {
    listQuery: {
      pageNum: 1,
      pageSize: 10,
      beginTime: "",
      endTime: "",
      tradeNo: "",
      companyName: "",
    },
    list: [],
    total: 0,
  };
  async componentDidMount() {
    NProgress.start();
    await this.getList();
    NProgress.done();
  }
  getList = () => {
    fetchRefundRecord(this.state.listQuery).then((res) => {
      if (res.success) {
        console.log(res);
        this.setState({
          list: res.data.list,
          total: res.data.total,
        });
      }
    });
  };
  handleExport = () => {
    const { beginTime, endTime, tradeNo, companyName } = this.state.listQuery;
    window.location.href =
      process.env.REACT_APP_API_PREFIX +
      `statistics/refund/list/export?beginTime=${beginTime}&endTime=${endTime}&tradeNo=${tradeNo}&companyName=${companyName}&accessToken=${
        JSON.parse(sessionStorage.getItem("loginInfo")).accessToken
      }`;
  };
  dateChange = (date, dateString) => {
    this.setState({
      listQuery: {
        ...this.state.listQuery,
        beginTime: dateString[0],
        endTime: dateString[1],
      },
    });
  };
  handleChange = (e) => {
    const { listQuery } = this.state;
    switch (e.target.name) {
      case "tradeNo":
        this.setState({
          listQuery: { ...listQuery, tradeNo: e.target.value },
        });
        break;

      case "companyName":
        this.setState({
          listQuery: { ...listQuery, companyName: e.target.value },
        });
        break;
    }
  };
  handleSearch = () => {
    this.setState(
      {
        listQuery: { ...this.state.listQuery, pageNum: 1 },
      },
      () => this.getList()
    );
  };
  renderType = (value) => {
    switch (value) {
      case "EV200":
        return "EV200";
        break;
      case "X5":
        return "X5";
        break;
      default:
        break;
    }
  };
  renderPayType = (value) => {
    switch (value) {
      case "WECHAT":
        return "微信";
        break;
      case "ALIPAY":
        return "支付宝";
        break;
      case "UNION_PAY":
        return "银联支付";
        break;
      case "NUMBER":
        return "数字货币";
        break;
      default:
        break;
    }
  };
  render() {
    const { listQuery, total, list } = this.state;
    return (
      <div className="container">
        <Headers BreadCrumbData={BreadCrumbData}></Headers>
        <div
          style={{
            borderBottom: "1px solid #E8E8E8",
            borderRadius: "5px 5px 0 0",
            marginBottom: 0,
          }}
          className="searchTitle"
        >
          <Row>
            <Col span={22}>
              <RangePicker
                onChange={this.dateChange}
                style={{ width: 300, marginRight: 10 }}
              />
              <Input
                style={{ width: 150, marginRight: 10 }}
                placeholder="商户名称"
                allowClear
                name="companyName"
                onChange={this.handleChange}
              />
              <Input
                style={{ width: 220, marginRight: 10 }}
                placeholder="订单编号"
                allowClear
                name="tradeNo"
                onChange={this.handleChange}
              />
              {/* <Input
                style={{ width: 150, marginRight: 10 }}
                placeholder="物料名称"
                allowClear
                name="materialsName"
                onChange={this.handleChange}
              /> */}
              <Button type="primary" onClick={this.handleSearch}>
                搜索
              </Button>
            </Col>
            <Col span={2} align="right">
              <Button type="primary" onClick={this.handleExport}>
                导出
              </Button>
            </Col>
          </Row>
        </div>
        <div style={{ borderRadius: "0 0 5px 5px" }} className="content">
          <Table
            dataSource={list}
            rowKey={(value) => `${value}${Math.random()}`}
            pagination={{
              showTotal: () => `共${total}条`,
              current: listQuery.pageNum,
              total: total,
              pageSize: listQuery.pageSize,
              showSizeChanger: true,
              showQuickJumper: true,
              pageSizeOptions: ["10", "20", "30", "40", "100"],
              onChange: (page, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageNum: page },
                  },
                  () => this.getList()
                );
              },
              onShowSizeChange: (current, pageSize) => {
                this.setState(
                  {
                    listQuery: { ...listQuery, pageSize, pageNum: 1 },
                  },
                  () => this.getList()
                );
              },
            }}
          >
            <Column
              title="退款时间"
              dataIndex="refundsTime"
              key="refundsTime"
            />
            <Column
              title="商户名称"
              dataIndex="companyName"
              key="companyName"
            />
            <Column title="订单编号" dataIndex="tradeNo" key="tradeNo" />
            <Column
              title="设备类型"
              dataIndex="capsuleType"
              key="capsuleType"
              render={this.renderType}
            />
            <Column title="设备编号" dataIndex="capsuleNo" key="capsuleNo" />
            <Column title="货道号" dataIndex="aisleNo" key="aisleNo" />
            <Column
              title="商品名称"
              dataIndex="materialsName"
              key="materialsName"
            />
            <Column title="支付金额/元" dataIndex="price" key="price" />
            <Column
              title="支付方式"
              dataIndex="payType"
              key="payType"
              render={this.renderPayType}
            />
            <Column
              title="退款金额/元"
              dataIndex="refundsPrice"
              key="refundsPrice"
            />
            <Column
              title="退款原因"
              dataIndex="refundsReason"
              key="refundsReason"
            />
          </Table>
        </div>
      </div>
    );
  }
}

export default RefundRecord;
